import { Box } from '@chakra-ui/react';

const IconContainer = ({ children, size = 32 }) => {
  return (
    <Box
      height={`${size}px`}
      width={`${size}px`}
      sx={{
        transition: 'all 0.2s ease-in-out',
        ':hover': { WebkitFilter: 'brightness(85%)' },
      }}
    >
      {children}
    </Box>
  );
};

export default IconContainer;
